import React, { Fragment, useRef, useContext, useEffect, useState } from 'react'
import Header from 'Layout/Header'
import { Box, Container, Button, Grid, Typography, Modal } from '@mui/material'
import FileState from '../../Hooks/File.state';
import { UserContext } from '../../Hooks/UserContext';
import { PDFDocument, rgb } from 'pdf-lib';
import DriveWithUsState from 'Hooks/DriveWithUs.state';
import Signature from './Signature';
import VideoPlayer from 'Component/VideoPlayer';
import { Stepper, Step, StepLabel } from '@mui/material';
import { videosEnglish, videosSpanish } from './VideoData';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import 'pdfjs-dist/build/pdf.worker.mjs';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import Flag from 'react-world-flags';
import { base64pdf } from 'assets/file/base64pdf';
import { toast } from 'react-toastify';
import { GET_W9_TEMPLATE_URL } from '../../Utils/URLs';




const VideoSection = () => {
  const navigate = useNavigate()
  const [lang, setLang] = useState("")
  const { user,UpdateUser } = useContext(UserContext)
  const { fileformBusy, UploadFile, fileresponse } = FileState()
  const [signatureImage, setSignatureImage] = useState(null);

  const [completedSteps, setCompletedSteps] = useState([]);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [editedPdfUrl, setEditedPdfUrl] = useState(null);

  const steps = [0, 1, 2, 3, 4];
  const steps2 = [0, 1, 2, 3, 4, 5];
  const canvas1Ref = useRef(null);
  const canvas2Ref = useRef(null);
  const canvas3Ref = useRef(null);
  const canvas4Ref = useRef(null);
  const canvas5Ref = useRef(null);
  const canvas6Ref = useRef(null);
  const videoRefsEnglish = useRef([]);
  const videoRefsSpanish = useRef([]);
  const currentPdfBlobUrlRef = useRef(null);
  const lastPdfGenerationKeyRef = useRef(null);
  const uploadFileRef = useRef(UploadFile);

  // Auto-upload controls (prevents "sometimes doesn't upload" race conditions)
  const pendingAutoUploadRef = useRef(false);
  const autoUploadInFlightRef = useRef(false);
  const lastAutoUploadSignatureRef = useRef(null);

  useEffect(() => {
    uploadFileRef.current = UploadFile;
  }, [UploadFile]);



  useEffect(() => {
    // Check if the screen size is mobile
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    setIsMobile(mediaQuery.matches);

    const handleResize = () => setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleResize);

    // Cleanup the event listener on unmount
    return () => mediaQuery.removeEventListener('change', handleResize);
  }, []);

  const { formBusy, UpdateDriveWithUs, response, driveWithUsData, loading, GetDriveWithUs, oldData } = DriveWithUsState()

  const handleSignatureSave = (signature) => {
    console.log("Signature saved:", signature ? "Yes" : "No");
    setSignatureImage(signature);
    // When user presses "Save", we want upload to happen right away after PDF is regenerated
    if (signature) {
      pendingAutoUploadRef.current = true;
    } else {
      pendingAutoUploadRef.current = false;
      lastAutoUploadSignatureRef.current = null;
    }
  };

  useEffect(() => {
    if (user?.form_name === "drive_with_us") {
      GetDriveWithUs()
    }
  }, [user])

  useEffect(() => {
    videoRefsEnglish.current = videosEnglish.map((_, i) => videoRefsEnglish.current[i] || null);
    videoRefsSpanish.current = videosSpanish.map((_, i) => videoRefsSpanish.current[i] || null);
  }, []);


  const handleVideoEnd = (index, lang) => {
    const isEnglish = lang === "en";
    const videoRefs = isEnglish ? videoRefsEnglish.current : videoRefsSpanish.current;
    const nextIndex = index + 1;
    const updatedSteps = [...completedSteps];
    updatedSteps[index] = true;
    setCompletedSteps(updatedSteps);

    if (nextIndex < (isEnglish ? videosEnglish.length : videosSpanish.length)) {
      setCurrentVideoIndex(nextIndex);
      const nextVideoRef = videoRefs[nextIndex];
      if (nextVideoRef && nextVideoRef.plyr && nextVideoRef.plyr.media) {
        nextVideoRef.plyr.media.play(); // Auto-play the next video
      } else {
        console.error("Next video reference is undefined or does not support 'play' method");
      }
    }
  };


  useEffect(() => {
    if (!user) return;

    let isActive = true;
    const abortController = new AbortController();

    const requiredSteps = lang === "en" ? 5 : lang === "es" ? 6 : null;
    const completedCount = Array.isArray(completedSteps) ? completedSteps.filter(Boolean).length : 0;
    const trainingCompleted = requiredSteps != null && completedCount >= requiredSteps;

    // Don't keep regenerating PDF while user is still watching videos
    if (!trainingCompleted && !signatureImage) return;

    const editPdf = async () => {
      try {
        // Build a stable generation key to prevent "blink loops" on re-renders
        const ssDoc = Array.isArray(driveWithUsData)
          ? driveWithUsData.find((e) => e.field_name === "social_security")
          : null;
        const ssnDigits = String(ssDoc?.file_number || "")
          .replace(/\D/g, "")
          .trim()
          .slice(0, 9);
        const signatureKey = signatureImage ? `${signatureImage.length}:${signatureImage.slice(0, 24)}` : "";
        const generationKey = JSON.stringify({
          userId: user?._id || "",
          first_name: user?.first_name || "",
          last_name: user?.last_name || "",
          address: user?.address || "",
          apt: user?.apt || "",
          city: user?.city || "",
          state: user?.state || "",
          zip_code: user?.zip_code || "",
          ssn: ssnDigits,
          lang: lang || "",
          completedCount,
          signatureKey,
        });

        if (generationKey === lastPdfGenerationKeyRef.current) return;
        lastPdfGenerationKeyRef.current = generationKey;

        // const firstPdfUrl = `${process.env.PUBLIC_URL}/assets/file/Form_W-9_(Rev._October_2018).pdf`;
        // const firstPdfUrl = `../../assets/file/Form_W-9_(Rev._October_2018).pdf`;
        // const firstPdfBytes = await fetch(firstPdfUrl,{
        //   headers: { 'X-Requested-With': 'XMLHttpRequest' }
        // })
        //   .then((res) => {
        //     if (!res.ok) throw new Error(`Failed to fetch PDF: ${res.statusText}`);
        //     return res.arrayBuffer();
        //   });
        let firstPdfBytes;
        try {
          const res = await fetch(GET_W9_TEMPLATE_URL, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: abortController.signal
          });
          if (!res.ok) throw new Error(`Failed to fetch template PDF: ${res.status} ${res.statusText}`);
          const arrayBuffer = await res.arrayBuffer();
          firstPdfBytes = new Uint8Array(arrayBuffer);
        } catch (err) {
          // Fallback to bundled template (so app still works if API/template is down)
          console.warn("Template fetch failed; falling back to bundled base64 PDF.", err);
          const base64Data = base64pdf.split(',')[1];
          firstPdfBytes = Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));
        }

        const firstPdfDoc = await PDFDocument.load(firstPdfBytes);

        const pages = firstPdfDoc.getPages();
        pages.forEach((page, index) => {
          const { width, height } = page.getSize();
          console.log(`Page ${index + 1}: width = ${width}, height = ${height}`);
        });
        console.log("firstPdfDoc", pages)
        const firstPage = pages[0];
        const secondPage = pages[1];
        const lastPage = pages[pages.length - 1];
        const { width: firstPageWidth, height: firstPageHeight } = firstPage.getSize();
        firstPage.drawText(`${user?.first_name} ${user?.last_name}`, { x: 67, y: firstPageHeight - 105, size: 8, color: rgb(0, 0, 0) });
        firstPage.drawText(`${user?.address}, ${user?.apt}`, { x: 67, y: firstPageHeight - 263, size: 8, color: rgb(0, 0, 0) });
        firstPage.drawText(`${user?.city}, ${user?.state}, ${user?.zip_code}`, { x: 67, y: firstPageHeight - 286, size: 8, color: rgb(0, 0, 0) });

        const drawTextWithLetterSpacing = (page, text, options, letterSpacing) => {
          const { x, y, size, color } = options;
          let currentX = x;
          for (let i = 0; i < text.length; i++) {
            const char = text[i];
            page.drawText(char, { x: currentX, y: y, size: size, color: color });
            currentX += size + letterSpacing;
          }
        };

        if (ssnDigits.length >= 9) {
          drawTextWithLetterSpacing(firstPage, ssnDigits.slice(0, 3), { x: firstPageWidth - 190, y: firstPageHeight - 352, size: 10, color: rgb(0, 0, 0) }, 4);
          drawTextWithLetterSpacing(firstPage, ssnDigits.slice(3, 5), { x: firstPageWidth - 133, y: firstPageHeight - 352, size: 10, color: rgb(0, 0, 0) }, 4);
          drawTextWithLetterSpacing(firstPage, ssnDigits.slice(5, 9), { x: firstPageWidth - 89, y: firstPageHeight - 352, size: 10, color: rgb(0, 0, 0) }, 4);
        }
        secondPage.drawText(` ${new Date().toISOString().slice(0, 10)}`, { x: firstPageWidth - 190, y: firstPageHeight - 285, size: 9, color: rgb(0, 0, 0) });
        secondPage.drawText(` ${new Date().toISOString().slice(0, 10)}`, { x: firstPageWidth - 190, y: firstPageHeight - 285, size: 9, color: rgb(0, 0, 0) });
        firstPage.drawText(` ${new Date().toISOString().slice(0, 10)}`, { x: firstPageWidth - 190, y: firstPageHeight - 561, size: 9, color: rgb(0, 0, 0) });
        secondPage.drawText(` ${user?.first_name} ${user?.last_name}`, { x: 80, y: firstPageHeight - 340, size: 9, color: rgb(0, 0, 0) });
        lastPage.drawText(` ${user?.first_name} ${user?.last_name}`, { x: 109, y: firstPageHeight - 596, size: 9, color: rgb(0, 0, 0) });
        if (signatureImage) {
          const signatureBytes = await fetch(signatureImage).then(res => res.arrayBuffer());
          const signatureImageEmbed = await firstPdfDoc.embedPng(signatureBytes);
          const { width, height } = signatureImageEmbed.size();
          const desiredWidth = 40; // Your desired width
          const desiredHeight = 40;
          firstPage.drawImage(signatureImageEmbed, { x: 140, y: 220, width: desiredWidth, height: desiredHeight })
          lastPage.drawImage(signatureImageEmbed, { x: 120, y: 220, width: 50, height: 50 });
        }
        const pdfBytes = await firstPdfDoc.save();
        const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Prevent blob URL leaks
        if (currentPdfBlobUrlRef.current) {
          try { URL.revokeObjectURL(currentPdfBlobUrlRef.current); } catch (_) {}
        }
        currentPdfBlobUrlRef.current = pdfUrl;

        if (isActive) setEditedPdfUrl(pdfUrl);
        console.log("PDF generated and stored:", pdfBlob.size, "bytes");
        
        // Auto upload when signature is available and training is completed.
        // Uses a "pending" flag so it reliably uploads after user presses Save.
        const canAutoUpload =
          !!signatureImage &&
          trainingCompleted &&
          pendingAutoUploadRef.current &&
          !autoUploadInFlightRef.current &&
          lastAutoUploadSignatureRef.current !== signatureImage;

        if (canAutoUpload) {
          console.log("Auto uploading document...");
          pendingAutoUploadRef.current = false;
          autoUploadInFlightRef.current = true;
          lastAutoUploadSignatureRef.current = signatureImage;
          try {
            const formData = new FormData();
            formData.append("file", pdfBlob, "document.pdf");
            formData.append("field_name", "w9");
            await uploadFileRef.current?.(formData);
          } finally {
            autoUploadInFlightRef.current = false;
          }
        }

      } catch (error) {
        if (error?.name === "AbortError") return;
        console.error('Error merging and modifying PDF:', error);
      }

    };

    // Run immediately; avoids races where timeout gets cleared by rapid re-renders
    editPdf();

    return () => {
      isActive = false;
      abortController.abort();
    };
  }, [user, driveWithUsData, signatureImage, lang, completedSteps]);

  // Render PDF pages to canvases using pdf.js (no browser PDF toolbar)
  useEffect(() => {
    if (!editedPdfUrl) return;

    let isActive = true;
    const loadingTask = pdfjsLib.getDocument(editedPdfUrl);

    const render = async () => {
      try {
        // Wait one frame so canvases are mounted
        await new Promise((r) => requestAnimationFrame(r));

        const pdf = await loadingTask.promise;
        const canvasRefs = [canvas1Ref, canvas2Ref, canvas3Ref, canvas4Ref, canvas5Ref, canvas6Ref];
        const pagesToRender = Math.min(canvasRefs.length, pdf.numPages || 0);
        const scale = 1.5;

        for (let i = 1; i <= canvasRefs.length; i++) {
          if (!isActive) return;

          const canvas = canvasRefs[i - 1].current;
          if (!canvas) continue;

          // Hide extra canvases if PDF has fewer pages
          canvas.style.display = i <= pagesToRender ? "block" : "none";
          if (i > pagesToRender) continue;

          const page = await pdf.getPage(i);
          const viewport = page.getViewport({ scale });
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          const ctx = canvas.getContext("2d");
          if (!ctx) continue;

          await page.render({ canvasContext: ctx, viewport }).promise;
        }
      } catch (err) {
        console.error("Error rendering PDF to canvas:", err);
      }
    };

    render();

    return () => {
      isActive = false;
      try {
        loadingTask.destroy();
      } catch (_) {
        // ignore
      }
    };
  }, [editedPdfUrl]);


  // useEffect(() => {
  //   const editPdf = async () => {
  //     try {
  //       const firstPdfUrl = `${process.env.PUBLIC_URL}/assets/file/Form_W-9_(Rev._October_2018).pdf.txt`;

  //       const firstPdfBytes = await fetch(firstPdfUrl).then(res => {
  //         if (!res.ok) throw new Error(`Failed to fetch PDF: ${res.statusText}`);
  //         return res.arrayBuffer();
  //       });

  //       const firstPdfDoc = await PDFDocument.load(firstPdfBytes);
  //       const pages = firstPdfDoc.getPages();
  //       const firstPage = pages[0];
  //       const secondPage = pages[1];
  //       const lastPage = pages[pages.length - 1];
  //       const { width, height } = firstPage.getSize();

  //       // Fill text fields
  //       firstPage.drawText(`${user?.first_name} ${user?.last_name}`, { x: 67, y: height - 105, size: 8, color: rgb(0, 0, 0) });
  //       firstPage.drawText(`${user?.address}, ${user?.apt}`, { x: 67, y: height - 263, size: 8, color: rgb(0, 0, 0) });
  //       firstPage.drawText(`${user?.city}, ${user?.state}, ${user?.zip_code}`, { x: 67, y: height - 286, size: 8, color: rgb(0, 0, 0) });

  //       const drawTextWithSpacing = (page, text, options, letterSpacing) => {
  //         const { x, y, size, color } = options;
  //         let currentX = x;
  //         for (let char of text) {
  //           page.drawText(char, { x: currentX, y, size, color });
  //           currentX += size + letterSpacing;
  //         }
  //       };

  //       drawTextWithSpacing(firstPage, `${security_number?.slice(0, 3)}`, { x: width - 190, y: height - 352, size: 10, color: rgb(0, 0, 0) }, 4);
  //       drawTextWithSpacing(firstPage, `${security_number?.slice(3, 5)}`, { x: width - 133, y: height - 352, size: 10, color: rgb(0, 0, 0) }, 4);
  //       drawTextWithSpacing(firstPage, `${security_number?.slice(5, 9)}`, { x: width - 89, y: height - 352, size: 10, color: rgb(0, 0, 0) }, 4);

  //       const today = new Date().toISOString().slice(0, 10);
  //       firstPage.drawText(today, { x: width - 190, y: height - 561, size: 9, color: rgb(0, 0, 0) });
  //       secondPage.drawText(today, { x: width - 190, y: height - 285, size: 9, color: rgb(0, 0, 0) });
  //       secondPage.drawText(`${user?.first_name} ${user?.last_name}`, { x: 80, y: height - 340, size: 9, color: rgb(0, 0, 0) });
  //       lastPage.drawText(`${user?.first_name} ${user?.last_name}`, { x: 109, y: height - 596, size: 9, color: rgb(0, 0, 0) });

  //       // Signature
  //       if (signatureImage) {
  //         const signatureBytes = await fetch(signatureImage).then(res => res.arrayBuffer());
  //         const signatureImageEmbed = await firstPdfDoc.embedPng(signatureBytes);
  //         firstPage.drawImage(signatureImageEmbed, { x: 140, y: 220, width: 40, height: 40 });
  //         lastPage.drawImage(signatureImageEmbed, { x: 120, y: 220, width: 50, height: 50 });
  //       }

  //       const pdfBytes = await firstPdfDoc.save();
  //       const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
  //       const pdfUrl = URL.createObjectURL(pdfBlob);

  //       setEditedPdfUrl(pdfUrl);

  //       // Optional upload logic
  //       const shouldUpload = (lang === "en" && completedSteps.length === 5) || (lang !== "en" && completedSteps.length === 6);
  //       if (shouldUpload && signatureImage) {
  //         const formData = new FormData();
  //         formData.append("file", pdfBlob, "document.pdf");
  //         formData.append("field_name", "w9");
  //         UploadFile(formData);
  //       }

  //     } catch (error) {
  //       console.error("Error editing PDF:", error);
  //     }
  //   };

  //   if (user ) {
  //     const timeoutId = setTimeout(editPdf, 100);
  //     return () => clearTimeout(timeoutId);
  //   }
  // }, [user, signatureImage, lang, completedSteps]);
  useEffect(() => {
    if (fileresponse.type === "success") {
      // Get user from localStorage, update isFormSubmit, and store back
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const userData = JSON.parse(storedUser);
        userData.isFormSubmit = "1";
        localStorage.setItem("user", JSON.stringify(userData));
        UpdateUser(userData)
      }
      
      toast.success(fileresponse.message || "Document uploaded successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      
      // Redirect to profile after a short delay
      setTimeout(() => {
        navigate("/driver_forms/profile");
      }, 2000);
    } else if (fileresponse.type === "error") {
      toast.error(fileresponse.message || "Failed to upload document", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }, [fileresponse, navigate])

  useEffect(() => {
    videoRefsEnglish.current = videosEnglish.map((_, i) => videoRefsEnglish.current[i] || null);
    videoRefsSpanish.current = videosSpanish.map((_, i) => videoRefsSpanish.current[i] || null);
  }, []);

  // Attach native HTML5 video event listeners
  useEffect(() => {
    // Attach listeners to English videos
    videoRefsEnglish.current.forEach((videoRef, index) => {
      if (videoRef && videoRef.plyr) {
        const videoElement = videoRef.plyr.elements.container.querySelector("video");
        if (videoElement) {
          videoElement.addEventListener("ended", () => handleVideoEnd(index, "en"));
        }
      }
    });

    // Attach listeners to Spanish videos
    videoRefsSpanish.current.forEach((videoRef, index) => {
      if (videoRef && videoRef.plyr) {
        const videoElement = videoRef.plyr.elements.container.querySelector("video");
        if (videoElement) {
          videoElement.addEventListener("ended", () => handleVideoEnd(index, "es"));
        }
      }
    });

    // Cleanup listeners when the component unmounts
    return () => {
      videoRefsEnglish.current.forEach((videoRef) => {
        if (videoRef && videoRef.plyr) {
          const videoElement = videoRef.plyr.elements.container.querySelector("video");
          if (videoElement) {
            videoElement.removeEventListener("ended", handleVideoEnd);
          }
        }
      });

      videoRefsSpanish.current.forEach((videoRef) => {
        if (videoRef && videoRef.plyr) {
          const videoElement = videoRef.plyr.elements.container.querySelector("video");
          if (videoElement) {
            videoElement.removeEventListener("ended", handleVideoEnd);
          }
        }
      });
    };
  }, [videosEnglish, videosSpanish]);

let height="70vh"
if(lang==="en" && completedSteps.length===5){
  height="115vh"
}else if(lang==="es" && completedSteps.length===6){ 
  height="110vh"
}else{
  height="70vh"
}

  return (
    <Box sx={{height:{xs:"100%",md:"100%"}}}  >
      <div className="cover-image pb-3 pb-md-0" style={{ position: "relative" }} >
        <Header />
        <Container sx={{ pt: { xs: 1, md: 4 } }} >

          <Box sx={{ textAlign: "start" }} >
            <Typography component="h1" fontSize={{ xs: 20, md: 30, lg: 39 }} sx={{ color: "#FFF" }} >Welcome {user?.first_name} {user?.last_name}  </Typography>

          </Box>
        </Container>
      </div>

      {lang.length === 0 ?
        <>



          <Box sx={{ pt: {xs:0,md:8},pb:{xs:0,md:8},height:{xs:"70vh",md:"100%"}, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} >

            <Typography component="h1" sx={{ fontSize: 30 }}  >Select your language</Typography>
            <Box my={10} >
              <Row>
                <Col xs={6} >
                  <Button onClick={() => setLang("en")} sx={{ backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }} variant='contained' startIcon={<Flag code='GB' style={{ width: 24, height: 24, marginRight: 8 }} />} >English</Button>
                </Col>
                <Col xs={6} >
                  <Button onClick={() => setLang("es")} sx={{ backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }} variant='contained' startIcon={<Flag code='ES' style={{ width: 24, height: 24, marginRight: 8 }} />} >Spanish</Button>
                </Col>
              </Row>
              {/* <LanguageSelector value={lang} onChange={(e) => setLang(e)} /> */}
            </Box>


          </Box>

        </>
        :
        <>

          {/* <div className="cover-image pb-3 pb-md-0" >
            <Header />
            <Container sx={{ pt: 4 }} >

              <Box sx={{ textAlign: "start" }} >
                <Typography component="h1" fontSize={{ xs: 20, md: 30, lg: 39 }} sx={{ color: "#FFF" }} >Welcome {user?.first_name} {user?.last_name}  </Typography>

              </Box>
            </Container>
          </div> */}
          <Container maxWidth="xl" sx={{ height:{xs:height,md:"100%"},mb:{xs:0,md:10} }} >

            <Grid container justifyContent={"center"}>

              {lang === "en" ? (
                completedSteps.length !== 5 ? (
                  <Grid item xs={12} md={7} mt={10} >
                    <h2
                      className="elementor-heading-title elementor-size-default"
                      style={{ color: "#021B38", textAlign: "center", marginBottom: 0, marginTop: 10 }}
                    >
                      Watch The Get Better Transportation Training Guide
                      <b style={{ color: "#97c11e" }}>//</b>
                    </h2>
                    <Stepper activeStep={-1} sx={{ mt: 2 }}>
                      {steps.map((label, index) => (
                        <Step key={label} completed={completedSteps[index]}>
                          <StepLabel></StepLabel>
                        </Step>
                      ))}
                    </Stepper>

                    <Grid container>

                      {videosEnglish.map((video, index) => (
                        completedSteps.length === index && (
                          <Grid item xs={12} md={12} px={1} key={index}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center",
                                position: "relative"
                              }}
                              mt={2}
                            >
                              <VideoPlayer
                                key={index}
                                sources={video}

                                ref={(el) => {
                                  if (el && !videoRefsEnglish.current[index]) {
                                    videoRefsEnglish.current[index] = el;
                                  }
                                }}
                                onEnded={() => handleVideoEnd(index, "en")}

                                options={{
                                  autoplay: completedSteps.length > 0 ? true : false,
                                  controls: [
                                    'play',
                                    'current-time',
                                    'duration',
                                    "progress",
                                    'mute',
                                    'volume',
                                    'fullscreen',
                                    // 'settings' is omitted to hide the settings menu
                                  ],
                                }}
                              />
                            </Box>
                          </Grid>
                        )
                      ))}
                    </Grid>
                  </Grid>
                ) : (
                  // This section will only render after all English videos are watched
                  <Grid  mb={{xs:0,md:10}}  item xs={12} md={12} pt={4} display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"}>
                    <h2
                      className="elementor-heading-title elementor-size-default"
                      style={{ color: "#021B38", textAlign: "center", marginBottom: 0, marginTop: 0 }}
                    >
                      INDEPENDENT DRIVER CONTRACTOR AGREEMENT
                      <b style={{ color: "#97c11e" }}>//</b>
                    </h2>
                    <h4 className="elementor-heading-title elementor-size-default" style={{ textAlign: "center" }}></h4>
                    <Grid container pt={3} justifyContent={"center"}>
                      <Grid item xs={12} md={12} display={"flex"} mx={{ xs: 2, md: 5 }} mb={3} position={"relative"}>
                        <Box height={500} overflow={!isMobile ? "auto" : "hidden"} width={"100%"} display={"flex"} flexDirection={"column"} alignItems={"center"}  >

                          {editedPdfUrl ? (
                            <>
                              <canvas style={{ width: "100%" }} ref={canvas1Ref}></canvas>
                              <canvas style={{ width: "100%" }} ref={canvas2Ref}></canvas>
                              <canvas style={{ width: "100%" }} ref={canvas3Ref}></canvas>
                              <canvas style={{ width: "100%" }} ref={canvas4Ref}></canvas>
                              <canvas style={{ width: "100%" }} ref={canvas5Ref}></canvas>
                              <canvas style={{ width: "100%" }} ref={canvas6Ref}></canvas>
                            </>
                          ) : (
                            <p>Loading PDF...</p>
                          )}

                          {isMobile && (
                            <div
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                color: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                zIndex: 10,
                              }}
                              onClick={() => window.open(`${editedPdfUrl}#navpanes=0&toolbar=0`, "__blank")}
                            >
                              Click to Open
                            </div>
                          )}
                        </Box>
                      </Grid>
                      <Grid item xs={12} mx={{ xs: 2, md: 5 }}>
                        <Signature 
                          onSignatureSave={handleSignatureSave} 
                          fileformBusy={fileformBusy}
                        />
                      </Grid>
                      {/* <Grid item xs={12} md={6} lg={6} textAlign={"center"}>
                        <Box sx={{ px: { base: 5, md: 2, lg: 5 }, mb: 4 }}>
                          <Button
                            fullWidth
                            onClick={handleFileChange}
                            startIcon={<CloudUploadIcon />}
                            sx={{ backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }}
                            disableElevation
                            size="large"
                            variant="contained"
                            color="secondary"
                          >
                            {fileformBusy ? "Please wait..." : "Upload Form"}
                          </Button>
                        </Box>
                      </Grid> */}
                    </Grid>
                  </Grid>
                )
              ) : (
                completedSteps.length !== 6 ? (
                  <Grid item xs={12} md={7} mt={10} >
                    <h2
                      className="elementor-heading-title elementor-size-default"
                      style={{ color: "#021B38", textAlign: "center", marginBottom: 0, marginTop: 10 }}
                    >
                      Watch The Get Better Transportation Training Guide
                      <b style={{ color: "#97c11e" }}>//</b>
                    </h2>
                    <Stepper activeStep={-1} sx={{ mt: 2 }}>
                      {steps2.map((label, index) => (
                        <Step key={label} completed={completedSteps[index]}>
                          <StepLabel></StepLabel>
                        </Step>
                      ))}
                    </Stepper>

                    <Grid container>

                      {videosSpanish.map((video, index) => (
                        completedSteps.length === index && (
                          <Grid item xs={12} md={12} px={1} key={index}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center"
                              }}
                              mt={2}
                            >
                              <VideoPlayer
                                key={index}
                                ref={(el) => {
                                  if (el && !videoRefsSpanish.current[index]) {
                                    videoRefsSpanish.current[index] = el;
                                  }
                                }}
                                sources={video}
                                onEnded={() => handleVideoEnd(index, "sp")}
                                options={{
                                  autoplay: completedSteps.length > 0 ? true : false,
                                  controls: [
                                    'play',
                                    'current-time',
                                    'duration',
                                    // "progress",
                                    'mute',
                                    'volume',
                                    'fullscreen',

                                  ],
                                }}
                              />

                            </Box>
                          </Grid>
                        )
                      ))}
                    </Grid>
                  </Grid>
                ) : (
                  // This section will only render after all Spanish videos are watched
                  <Box sx={{height:"100vh",mb:{xs:0,md:10}}} >
                  <Grid item xs={12} md={12} pt={4} display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"}>
                    <h2
                      className="elementor-heading-title elementor-size-default"
                      style={{ color: "#021B38", textAlign: "center", marginBottom: 0, marginTop: 0 }}
                    >
                      INDEPENDENT DRIVER CONTRACTOR AGREEMENT
                      <b style={{ color: "#97c11e" }}>//</b>
                    </h2>
                    <h4 className="elementor-heading-title elementor-size-default" style={{ textAlign: "center" }}></h4>
                    <Grid container pt={3} justifyContent={"center"}>
                      <Grid item xs={12} md={12} display={"flex"} mx={{ xs: 2, md: 5 }} mb={3} position={"relative"}  >
                        <Box height={500} overflow={!isMobile ? "auto" : "hidden"} width={"100%"} display={"flex"} flexDirection={"column"} alignItems={"center"}>

                          {editedPdfUrl ? (
                            <>
                              <canvas style={{ width: "100%" }} ref={canvas1Ref}></canvas>
                              <canvas style={{ width: "100%" }} ref={canvas2Ref}></canvas>
                              <canvas style={{ width: "100%" }} ref={canvas3Ref}></canvas>
                              <canvas style={{ width: "100%" }} ref={canvas4Ref}></canvas>
                              <canvas style={{ width: "100%" }} ref={canvas5Ref}></canvas>
                              <canvas style={{ width: "100%" }} ref={canvas6Ref}></canvas>
                            </>
                          ) : (
                            <p>Loading PDF...</p>
                          )}

                          {isMobile && (
                            <div
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                color: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                zIndex: 10,
                              }}
                              onClick={() => window.open(`${editedPdfUrl}#navpanes=0&toolbar=0`, "__blank")}
                            >
                              Click to Open
                            </div>
                          )}
                        </Box>
                      </Grid>
                      <Grid item xs={12} mx={{ xs: 2, md: 5 }}>
                        <Signature 
                          onSignatureSave={handleSignatureSave} 
                          fileformBusy={fileformBusy}
                        />
                      </Grid>
                      {/* <Grid item xs={12} md={6} lg={6} textAlign={"center"}>
                        <Box sx={{ px: { base: 5, md: 2, lg: 5 }, mb: 4 }}>
                          <Button
                            fullWidth
                            onClick={handleFileChange}
                            startIcon={<CloudUploadIcon />}
                            sx={{ backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }}
                            disableElevation
                            size="large"
                            variant="contained"
                            color="secondary"
                          >
                            {fileformBusy ? "Please wait..." : "Upload Form"}
                          </Button>
                        </Box>
                      </Grid> */}
                    </Grid>
                  </Grid>
                  </Box>
                )
              )}
            </Grid>

          </Container>

        </>
      }

    </Box>
  )
}

export default VideoSection